import {
  FORGETPASSWORD_FAIL,
  FORGETPASSWORD_REQUEST,
  FORGETPASSWORD_SUCCESS,
} from "../../constants/actions";

const initialState = {
  loading: false,
  newPass: false,
  error: false
};

const forgotPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case FORGETPASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FORGETPASSWORD_SUCCESS:
      return {
        loading: false,
        newPass: true,
        error: false,
      };
    case FORGETPASSWORD_FAIL:
      return {
        loading: false,
        newPass: false,
        error: true,
      };
    default:
      return state;
  }
};

export default forgotPasswordReducer;
